<template>
    <div class="adkar windows">
        <div class="flex">
            <div class="adkar-div" @click="sabah()">
                <p> أذكار الصباح </p>
            </div>
            <div class="adkar-div" @click="masa()">
                <p> أذكار المساء </p>
            </div>
            <div class="adkar-div" @click="sala()">
                <p> أذكار الصلاة </p>
            </div>
            <div class="adkar-div" @click="lail()">
                <p> أذكار الليل </p>
            </div>
            <br><br>
        </div>
        
        <transition name="sliderr" type="transition" mode="out-in" appear>
            <sabah-cmp v-if="sabahWindow" @closeSabah="sabahWindow = $event"></sabah-cmp>
        </transition>
        <transition name="sliderr" type="transition" mode="out-in" appear>
            <masa-cmp v-if="masaWindow" @closeMasa="masaWindow = $event"></masa-cmp>
        </transition>
        <transition name="sliderr" type="transition" mode="out-in" appear>
            <sala-cmp v-if="salaWindow" @closeSala="salaWindow = $event"></sala-cmp>
        </transition>
        <transition name="sliderr" type="transition" mode="out-in" appear>
            <lail-cmp v-if="lailWindow" @closeLail="lailWindow = $event"></lail-cmp>
        </transition>
        <span class="thx" title="notify"></span>
    </div>
</template>
<!-- <script src="../js/main.js"></script> -->
<script>
import asabah from "./adkar-cmp/sabah-cmp.vue"
import amasa from "./adkar-cmp/masa-cmp.vue"
import asala from "./adkar-cmp/sala-cmp.vue"
import alail from "./adkar-cmp/lail-cmp.vue"
        
export default {
    data() {
        return {
            sabahWindow: false,
            masaWindow: false,
            salaWindow: false,
            lailWindow: false
        }
    },
    methods: {
        sabah() {this.sabahWindow = !this.sabahWindow;},
        masa() {this.masaWindow = !this.masaWindow;},
        sala() {this.salaWindow = !this.salaWindow;},
        lail() {this.lailWindow = !this.lailWindow;}
    },
    components: {
        sabahCmp: asabah,
        masaCmp: amasa,
        salaCmp: asala,
        lailCmp: alail

    }  
    
}
</script>


  




  
<style scoped>
.sliderr-enter-active, .sliderr-leave-active {
  transition: all .5s ease;
}
.sliderr-enter, .sliderr-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}  
</style>
